export default __webpack_public_path__ + "static/media/a017-b.b3a1cff8.svg";